import React from 'react';
import { arrayOf, number, object, shape, string } from 'prop-types';
import { Drawer, Empty } from 'antd';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import { LoaderOverlay, Memberships } from 'vdlib';
import UpgradeMembershipModal from 'components/bids/UpgradeMembershipModal';
import OnlineAuctionsDrawerItem from './OnlineAuctionsDrawerItem';

const OnlineAuctionsDrawer = ({
  createBid,
  creatingAuctionBidsFor,
  fetchingOnlineAuctions,
  membership,
  onCloseDrawer,
  onlineAuctions,
  partyId,
  visible,
  merchantFees,
  membershipId,
}) => {
  const [showUpgradeModal, setShowUpgradeModal] = React.useState(false);

  const handleBidSubmit = React.useCallback(
    (Amount, auction) => {
      const eligible =
        membership &&
        (membership.Description !== Memberships.Bronze ||
          auction.MarketValue < 7000);
      if (!eligible) setShowUpgradeModal(true);
      else createBid(auction.ID, [{ Amount }], partyId);
    },
    [createBid, membership, partyId]
  );

  return (
    <Drawer
      title="LIVE Auctions"
      placement="right"
      onClose={onCloseDrawer}
      visible={visible}
      mask={false}
      maskClosable={false}
      style={{ marginTop: 50, height: 'calc(100vh - 50px)' }}
      width={500}
    >
      <LoaderOverlay loading={fetchingOnlineAuctions} />{' '}
      {onlineAuctions && onlineAuctions.length > 0 ? (
        <CSSTransitionGroup
          transitionName="cubic-bezier-opacity-below"
          transitionAppear={true}
          transitionAppearTimeout={500}
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}
          component={'div'}
        >
          {onlineAuctions.map(auction => (
            <OnlineAuctionsDrawerItem
              auction={auction}
              key={auction.ID}
              loading={creatingAuctionBidsFor === auction.ID}
              onBid={handleBidSubmit}
              open={visible}
              partyId={partyId}
              merchantFees={merchantFees}
              membershipID={membershipId}
            />
          ))}
        </CSSTransitionGroup>
      ) : !fetchingOnlineAuctions ? (
        <Empty />
      ) : null}
      <UpgradeMembershipModal
        show={showUpgradeModal}
        onHide={() => setShowUpgradeModal(false)}
      />
    </Drawer>
  );
};

OnlineAuctionsDrawer.propTypes = {
  onlineAuctions: arrayOf(
    shape({
      ID: number,
      EndDate: object, // moment
      VehicleBrand: String,
      VehicleModel: string,
    })
  ),
};

export default OnlineAuctionsDrawer;
